export default __webpack_public_path__ + "static/media/sim-monaco.93125fc6.jpg";